import { useState, useEffect } from 'react';
import API from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { StatusBadge } from '@/components/StatusBadge';
import { Plus, Pencil, Trash2 } from 'lucide-react';
import { toast } from 'sonner';

export default function Clientes() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [nombre, setNombre] = useState('');
  const [tipoCliente, setTipoCliente] = useState('general');
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    try { const res = await API.get('/catalogs/clients'); setItems(res.data); } catch { toast.error('Error cargando clientes'); }
  };
  useEffect(() => { fetchData(); }, []);

  const handleSave = async () => {
    if (!nombre.trim()) { toast.error('Ingresa un nombre'); return; }
    setLoading(true);
    try {
      if (editing) {
        await API.put(`/catalogs/clients/${editing.id}`, { nombre, tipo_cliente: tipoCliente });
        toast.success('Cliente actualizado');
      } else {
        await API.post('/catalogs/clients', { nombre, tipo_cliente: tipoCliente });
        toast.success('Cliente creado');
      }
      setOpen(false); setEditing(null); setNombre(''); setTipoCliente('general');
      fetchData();
    } catch (err) { toast.error(err.response?.data?.detail || 'Error'); } finally { setLoading(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Eliminar este cliente?')) return;
    try { await API.delete(`/catalogs/clients/${id}`); toast.success('Eliminado'); fetchData(); } catch { toast.error('Error'); }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-xl font-semibold">Clientes</h1>
          <p className="text-sm text-muted-foreground">Catálogo de clientes</p>
        </div>
        <Button onClick={() => { setEditing(null); setNombre(''); setTipoCliente('general'); setOpen(true); }} className="bg-[#0F6E87] hover:bg-[#0C5D73]" data-testid="table-create-button">
          <Plus className="h-4 w-4 mr-1" /> Nuevo
        </Button>
      </div>
      <Card className="bg-white border"><CardContent className="p-0">
        <Table>
          <TableHeader><TableRow className="bg-muted/30">
            <TableHead>Nombre</TableHead><TableHead>Tipo</TableHead><TableHead className="text-right">Acciones</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {items.length === 0 && <TableRow><TableCell colSpan={3} className="text-center text-muted-foreground py-8">No hay clientes</TableCell></TableRow>}
            {items.map(item => (
              <TableRow key={item.id} className="hover:bg-muted/40">
                <TableCell className="font-medium">{item.nombre}</TableCell>
                <TableCell><StatusBadge status={item.tipo_cliente} /></TableCell>
                <TableCell className="text-right">
                  <Button variant="ghost" size="icon" className="h-7 w-7" onClick={() => { setEditing(item); setNombre(item.nombre); setTipoCliente(item.tipo_cliente); setOpen(true); }}><Pencil className="h-3.5 w-3.5" /></Button>
                  <Button variant="ghost" size="icon" className="h-7 w-7 text-red-500" onClick={() => handleDelete(item.id)}><Trash2 className="h-3.5 w-3.5" /></Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent></Card>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>{editing ? 'Editar' : 'Nuevo'} Cliente</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><label className="text-sm font-medium">Nombre</label><Input value={nombre} onChange={(e) => setNombre(e.target.value)} placeholder="Nombre del cliente" className="mt-1" data-testid="field-nombre" autoFocus /></div>
            <div><label className="text-sm font-medium">Tipo de Cliente</label>
              <Select value={tipoCliente} onValueChange={setTipoCliente}>
                <SelectTrigger className="mt-1"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="general">General</SelectItem>
                  <SelectItem value="ledezma">Especial - Ledezma</SelectItem>
                  <SelectItem value="mario">Especial - Mario</SelectItem>
                </SelectContent>
              </Select>
              {tipoCliente !== 'general' && <p className="text-xs text-amber-600 mt-1">Este cliente se asignará automáticamente al almacén especial de {tipoCliente === 'ledezma' ? 'Ledezma' : 'Mario'}</p>}
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Cancelar</Button>
            <Button onClick={handleSave} disabled={loading} className="bg-[#0F6E87] hover:bg-[#0C5D73]" data-testid="entity-form-submit-button">{loading ? 'Guardando...' : 'Guardar'}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
